import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrashIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 18.5 20",
	style: { enableBackground: "new 0 0 18.5 20" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.trash-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "trash-icon-st0",
			d: "M17.5,4H1"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "trash-icon-st0",
			d: "M7.1,8.5v6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "trash-icon-st0",
			d: "M11.5,8.5v6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "trash-icon-st0",
			d: "M16.1,4v14.3c0,0.2-0.1,0.4-0.2,0.5S15.6,19,15.4,19H3.3c-0.2,0-0.4-0.1-0.5-0.2s-0.2-0.3-0.2-0.5V4"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "trash-icon-st0",
			d: "M13.1,4V2.5c0-0.4-0.2-0.8-0.4-1.1C12.4,1.1,12,1,11.6,1H7.1C6.7,1,6.3,1.1,6,1.4S5.5,2.1,5.5,2.5V4"
		})
	] }) }) })]
});
export default SvgTrashIcon;
